<template>
	<div class="wrap"  ref="slider" @click.self="close" v-show="sliderArg.flag">
		<div class="page">
			<div class="head">{{ title || "" }}</div>
			<div class="main">
				<slot></slot>
				<div class="inside-page" :class="{open:sliderArg.inside_index==0 && sliderArg.insideFlag == true}">
					<slot name="pass"></slot>
				</div>
				<div class="inside-page" :class="{open:sliderArg.inside_index==1 && sliderArg.insideFlag == true}">
					<slot name="notpass"></slot>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
    export default {
		props:["title","sliderArg"],  
		// sliderArg :{
		// 	flag:false,   //显示的 flag
		// 	inside_index:0,  //叠加的滑页序号
		// 	insideFlag:false, //是否展示叠加的滑页
		// },

		data(){
			return {
				bg_s:300,  //背景变化的时间 ms
				slider_s:600,  //滑页变化的时间 ms
				inside_s:400,  //增页变化时间

				bodydom:document.getElementsByTagName("body")[0],
				// insidePage:"", //额外滑页

			}
		},

		watch:{
			"sliderArg.flag"(val){
				if(val){
					this.bodydom.style.overflow = "hidden";
					setTimeout(()=>{this.$refs["slider"].classList.add("open")});
				}else{
					this.bodydom.style.overflow = "auto";
				}
			},
			// "sliderArg.insideFlag"(val){
			// 	this.insidePage[this.sliderArg.inside_index].classList.toggle("open");
			// }
		},

		mounted(){
			// this.setTransition();
		},

		methods:{
			close(){  //关闭回调
				this.$refs["slider"].classList.remove("open");
				setTimeout(()=>{
					this.sliderArg.flag = false;
					this.sliderArg.insideFlag = false;
					this.$emit("close");
				},this.bg_s);
			},
			// setTransition(){  //设置动画时间
			// 	setTimeout(()=>{
			// 		let slid = this.$refs["slider"];
			// 		slid.style.transition = `${this.bg_s}ms`;
			// 		slid.childNodes[0].style.transition = `${this.slider_s}ms`;

			// 		this.insidePage = document.getElementsByClassName("inside-page")[0].childNodes;
			// 		for(let i = 0,len=this.insidePage.length;i<len;i++){
			// 			this.insidePage[i].style.transition = `${this.inside_s}ms`;
			// 		}
			// 	})
			// },
		}

    }
</script>

<style lang="less" scoped>
	@bg_s: 300ms; //背景变化的时间 ms
	@slider_s: 600ms;  //滑页变化的时间 ms
	@inside_s: 400ms; //增页变化时间


	.wrap{
		position: fixed;
		height: 100%;
		width: 100%;
		top:0;
		left:0;
		background:rgba(0,0,0,0.6);
		@page-head:60px;
		transition: @bg_s;
		opacity: 0;
		
		&.open{
			opacity: 1;
			.page{
				transform: translateX(0);
			}
		}

		.page{
			position: absolute;
			overflow: hidden;
			background:#fff;
			right: 0;
			transform: translateX(100%);
			top: 0;
			height: 100%;
			width: 684px;
			box-sizing: border-box;
			padding-top: @page-head;
			transition:@slider_s;
			.head{
				position: absolute;
				top: 0;
				left: 0;
				width: 100%;
				height: @page-head;
				line-height: @page-head - 1px;
				box-sizing: border-box;
				text-align: center;
				font-size: 18px;
				color: #333;
				border-bottom: 1px solid #ccc;
			}
			.main{
				height: 100%;
				overflow: auto;
				.inside-page{
					@cha:3px; //补偿阴影
					display: block;
					position: absolute;
					top: @page-head;
					width: 100%;
					height: calc(~"100% - @{page-head}");
					left: calc(~"100% + @{cha}");
					box-shadow: -1px 2px 2px 2px rgba(185,185,185,0.8);
					background:#fff;
					opacity: 0;
					overflow: hidden;
					transition: @inside_s;
					&.open{
						transform: translateX(calc(~"-100% - @{cha}"));
						opacity: 1;
					}
				}
			}
		}
	}
</style>





// WEBPACK FOOTER //
// sliderPage.vue?aad5458e